import { mutate } from "swr";

export function editVateRate(franchiseID: any, updatedRows: any, dataIsUpdated: boolean | number,
    setDataIsUpdated: Function, setIsAddVatRateClicked: Function) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["tva"],
            data: updatedRows,
        }),
    };
    try {
        mutate(
            apiUrl,
            fetch(apiUrl, requestOptions)
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        throw Error("error");
                    } else {
                        setDataIsUpdated(!dataIsUpdated);
                        setIsAddVatRateClicked(false);
                    }
                })
        );
    } catch (e) { }
}